import React from 'react'

import { Navbar, Footer } from '../../../components';
import PremiumArticle from './PremiumArticle';

export default function Premarticle10() {
  return (
    <div className='emas__article1'>
        <Navbar />
        <PremiumArticle article="article10" headerImage="lighter.jpg" photographer="Bastian Riccardi (Pexels)" />
        <Footer />
    </div>
  )
}
